import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
//import "../App.css"
//import "../css/zto.css"
//import "../css/user.css"
import { toast } from "react-toastify";
import { Modal, Button, Form } from 'react-bootstrap';
import { FaTrash, FaCheckCircle, FaQuestionCircle, FaPen, FaLock, FaPlus, FaSearch, FaSortDown, FaSortUp, FaFilter } from 'react-icons/fa';
import { API_URL_All } from '../api';
import * as general from '../libs/general';
import Paging from '../components/Paging';
import OrderFilter from '../components/filters/OrderFilter';
import UserLayout from '../components/UserLayout';
import DataTable from '../components/ui/DataTable';
import OrderEditor from '../components/orders/OrderEditor';
import MultiOrderEditor from '../components/orders/MultiOrderEditor';
import OrderVatEditor from '../components/orders/OrderVatEditor';
import TransferRequester from '../components/orders/TransferRequester';
import { CheckingTicket, LockingTicket, EyeIcon } from '../components/tickets/Tickets';
import HistoryInfo from '../components/orders/HistoryInfo';
import axiosInstance from '../axiosInstance';
import AddOrderByExcelModal from '../components/orders/AddOrderByExcelModal';
import { formatOrderDateRangeLabel, normalizeOrderAdminDateRangeParams } from '../libs/lib-date-range-filter';
import {
  fetchOrdersDivisionPermissions,
  ORDER_EXCEL_EXPORT_FEATURES,
} from "../libs/customerCreatePermission";
import { canViewChildFeature, ORDER_COLUMNS } from "../libs/childUserPermission";

function OrderTable() {
  const [pageData, setPageData] = useState({ content: [] });
  const config = general.getLocalStorage("user_config");
  // Phân quyền cấp cột cho user con (root luôn thấy đủ - xem canViewChildFeature).
  const showColLine = canViewChildFeature(config, ORDER_COLUMNS.LINE);
  const showColCnCode = canViewChildFeature(config, ORDER_COLUMNS.CN_CODE);
  const showColVnCode = canViewChildFeature(config, ORDER_COLUMNS.VN_CODE);
  const showColProductName = canViewChildFeature(config, ORDER_COLUMNS.PRODUCT_NAME);
  const showColPackage = canViewChildFeature(config, ORDER_COLUMNS.PACKAGE);
  const showColWeightVolume = canViewChildFeature(config, ORDER_COLUMNS.WEIGHT_VOLUME);
  const showColInsurance = canViewChildFeature(config, ORDER_COLUMNS.INSURANCE);
  const showColShippingMethod = canViewChildFeature(config, ORDER_COLUMNS.SHIPPING_METHOD);
  const showColNote = canViewChildFeature(config, ORDER_COLUMNS.NOTE);
  const showColProgress = canViewChildFeature(config, ORDER_COLUMNS.PROGRESS);
  const showColReconcile = canViewChildFeature(config, ORDER_COLUMNS.RECONCILE);
  const shippingCodeColSpan = (showColCnCode ? 1 : 0) + (showColVnCode ? 1 : 0);
  const hasRun = useRef(false);
  const hasRun2 = useRef(false);
  const year = new Date().getFullYear();
  const [errorMessage, setErrorMessage] = useState("");
  const [isMyOrders, setIsMyOrders] = useState(true);

  const [vatEditorData, setVatEditorData] = useState(null);
  const [orderEditorData, setOrderEditorData] = useState(null);
  const [multiOrderEditorData, setMultiOrderEditorData] = useState(null);
  const [transterRequesterData, setTransterRequesterData] = useState(null);
  const [filterData, setFilterData] = useState(null);
  const [historyInfoData, setHistoryInfoData] = useState(null);

  const [totalPages, setTotalPages] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const user = useSelector((state) => state.user.user); // Lấy thông tin người dùng từ Redux
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');

  const [countCountOrderByStatusList, setCountOrderByStatusList] = useState([]);

  const [selectedOrders, setSelectedOrders] = useState([]);
  const [params, setParams] = useState({});
  const [addOrderByExelModal, setAddOrderByExelModal] = useState(false);

  const [orderScreenPerm, setOrderScreenPerm] = useState({
    loaded: false,
    menuView: false,
    normal: { view: false, create: false, edit: false, delete: false },
    vat: { view: false, create: false, edit: false, delete: false },
    excel: {},
    muaHo: false,
  });

  const orderExcelPerm = (divisionFeature) => Boolean(orderScreenPerm.excel?.[divisionFeature]);
  const anyOrderExcelPerm = ORDER_EXCEL_EXPORT_FEATURES.some((f) => orderExcelPerm(f));

  const requestSearchOrders = async (filter) => {
    var checkAllTag = document.querySelector('.check_all');
    if (checkAllTag) {
      checkAllTag.removeAttribute('data-unchecked');
      checkAllTag.checked = false;
    }
    setSelectedOrders([]);
    //setExpressFormData({});

    searchOrders(filter);
  }

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const p = await fetchOrdersDivisionPermissions(axiosInstance);
      if (cancelled) return;
      setOrderScreenPerm({
        loaded: true,
        menuView: Boolean(p?.menuView),
        normal: p.normal,
        vat: p.vat,
        excel: p.excel || {},
        muaHo: Boolean(p?.muaHo),
      });
    })();
    return () => {
      cancelled = true;
    };
  }, []);
  const searchOrders = async (filter) => {
    if (window.calling) return;
    window.calling = true;
    setIsLoading(true);
    var params = general.getSession('userorders');

    var formData = general.getFormData('#form_filter');
    const isFirstSearch = !hasRun2.current;
    if (isFirstSearch) {
      hasRun2.current = true;
      var oldForm = general.getSession('userorders');
      formData = oldForm;
    }
    Object.assign(params, formData);
    if (filter) Object.assign(params, filter);
    params = normalizeOrderAdminDateRangeParams({ params, formData, filter, isFirstSearch });
    general.setSession('userorders', params);
    setParams(params);
    window.initializeFilterValue(params);
    if (window.addFilterValue) {
      window.addFilterValue('dateRange', formatOrderDateRangeLabel(params.dateFrom, params.dateTo));
    }

    if (params.customers === 'ZTO-VH00') {
      setIsMyOrders(false)
    } else {
      setIsMyOrders(true);
    }
    //setSearchQuery(params.keyword);

    var filteredParams = Object.fromEntries(Object.entries(params).filter(([key, v]) => v !== undefined && v !== '' && key + v !== 'page0' && key + v !== 'size50' && key + v !== 'isDeletedfalse'));
    
    var response = {};
    setErrorMessage('');
    try {
      response = await axiosInstance.get(`/api/import-orders/searchorders`,{ params: filteredParams });

      setPageData(response.data);
      setTotalPages(response.data.page.totalPages);
      setCountOrderByStatusList(response.data.orderStatus);   

    } catch (error) {
      setErrorMessage(error.message);
      setPageData({ content: [] });
      console.error(error);
    }
    if (params.status) {
      var statusNames = params.status.split(';');
      var listStatus = response.data.orderStatus;
      listStatus.forEach(obj => {
        if (statusNames.includes(obj.name)) {
          obj.active = true;
        }
      });
    }

    var checkAllTag = document.querySelector('.check_all');
    if (checkAllTag) {
      checkAllTag.removeAttribute('data-listIds');
      if (response.data && response.data.listIds) {
        checkAllTag.setAttribute('data-listIds', response.data.listIds.join(","));
      }
    }

    setIsLoading(false);
    window.calling = false;
  };

  const handleSearchChange = (e) => {
    var searchValue = e.target.value;
    setSearchQuery(searchValue);
    requestSearchOrders({ page: 0, keyword: searchValue });
  };

  const handleOpenModal = async () => {
    setFilterData({});
  };

  const handleOrderStatusFilter = async (name) => {
    requestSearchOrders({ page: 0, status: name, outdate: '' });
  };

  const handleOutdateFilter = async (days) => {
    searchOrders({ page: 0, status: '', outdate: days });
  };

useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;
    searchOrders({ page: 0 });
    fetchConfig();
  }, []);

  const fetchConfig = async() => {
    var requestApi = `/api/users/getConfig`;
    try {
      var response = await axiosInstance.get(requestApi);
      general.setLocalStorage("user_config", response.data.data);
    } catch (error) {
      console.error(error);
    }

  };

  const handlePageChange = (page) => {
    searchOrders({ page: page - 1 });
  };

  const handleOrderEditor = (id) => {
    if (!config.code) {
      general.openConfirm(function () {
      }, "Tài khoản của bạn chưa được kích hoạt. Vui lòng liên hệ với ZTO để kích hoạt tài khoản của bạn.", "Thông báo");
      return;
    }
    setOrderEditorData({ id: id });
  };
  const handleEditor = (id, lineId, e) => {
    activeCurrentRow(e);

    if (lineId === 12) {
      handleOrderVatEditor(id);
      return;
    }
    handleOrderEditor(id);
  };

  const handleMultiOrderEditor = (obj) => {
    if (!obj) obj = {};
    setMultiOrderEditorData(obj);
  };
  const handleOrderVatEditor = (id) => {
    if (!config.code) {
      general.openConfirm(function () {

      }, "Tài khoản của bạn chưa được kích hoạt. Vui lòng liên hệ với ZTO để kích hoạt tài khoản của bạn.", "Thông báo");
      return;
    }
    setVatEditorData({ id: id });
  };

  const activeCurrentRow = (e) => {
    var targetTag = e.target;
    var tableTag = targetTag.closest('table');
    if (!tableTag) return;
    tableTag.querySelectorAll('tr').forEach(function (row) {
      row.classList.remove('active');
    });
    var trTag = targetTag.closest('tr');
    if (trTag) trTag.classList.add('active');
  };
  const handleViewHistoryInfo = (id, e) => {
    activeCurrentRow(e);

    var obj = { id: id, canEdit: true };
    setHistoryInfoData(obj);
  };
  const handleViewOrderDetailHistoryInfo = (orderDetailId, e) => {
    activeCurrentRow(e);

    var obj = { orderDetailId: orderDetailId, canEdit: true };
    setHistoryInfoData(obj);
  };
  const handleOpenTransferRequester = (obj) => {

    var listIds = selectedOrders;
    if (listIds.length === 0) {
      toast.error("Phải chọn ít nhất 1 mục");
      return;
    }
    if (!obj) obj = {};
    obj.listIds = listIds;
    setTransterRequesterData(obj);
  };
  const handleChangeItemsPerPage = (e) => {
    searchOrders({ page: 0, size: e.target.value });
  };

  function removeItem(array, value) {
    return array.filter(item => item !== value);
  };
  const handleSelectOrder = (id) => {
    setSelectedOrders((prevSelected) => {
      //console.log('prevSelected: ' + prevSelected);
      const updated = prevSelected.includes(id)
        ? prevSelected.filter((orderId) => orderId !== id)
        : [...prevSelected, id];

      var checkallTag = document.querySelector('.check_all');
      if (totalPages === 1) {
        var listOrders = pageData.page.content;
        const allChecked = listOrders.every(order => updated.includes(order.id));
        if (checkallTag) checkallTag.checked = allChecked;
      }
      var isChecked = updated.includes(id);
      var uncheckedList = checkallTag.getAttribute('data-unchecked');
      var idText = id + '';
      if (totalPages > 1 && (checkallTag.checked || uncheckedList)) {
        if (!uncheckedList) uncheckedList = '';
        var uncheckedItems = uncheckedList.split(',').filter(str => str !== "");
        if (isChecked) {
          uncheckedItems = removeItem(uncheckedItems, idText);
        } else {
          var isExisted = uncheckedItems.includes(idText);
          if (!isExisted) uncheckedItems.push(idText);
        }
        var textUncheckedItems = uncheckedItems.join(',');

        if (textUncheckedItems) {
          checkallTag.setAttribute('data-unchecked', textUncheckedItems);
          checkallTag.checked = false;
        } else {

          checkallTag.removeAttribute('data-unchecked');
          checkallTag.checked = true;
        }
      }

      return updated;
    }
    );
  };
  const handleSelectAll = () => {
    var checkAllTag = document.querySelector('.check_all');
    checkAllTag.removeAttribute('data-unchecked');
    var isChecked = checkAllTag.checked;
    if (!isChecked) {
      // Nếu tất cả đơn hàng đã được chọn, bỏ chọn tất cả
      setSelectedOrders([]);
    } else {
      // Nếu chưa chọn hết, chọn tất cả đơn hàng
      setSelectedOrders(pageData.listIds);
    }
  };
  const handleDeleteOrder = (id, e) => {
    general.openConfirm(async () => {
      try {
        var modelData = {};
        var requestApi = `/api/import-orders/deleteOrder/${id}`;
        const response = await axiosInstance.put(requestApi, modelData);

        if (!response.data.success) {
          toast.success(response.data.message);
          console.log(response.data);
          return;
        }
        requestSearchOrders({ page: 0 });
      } catch (error) {
        console.error(error);
        toast.error(error.message);
      }
    })
  };
  const handleAddOrderByExcel = () =>{
    setAddOrderByExelModal(true);
  }

  const handleCloseAddOrderByExcelModal = () => {
    setAddOrderByExelModal(false);
  };

  const downloadFileExcel = async (uri, fileName) => {
    var listIds = selectedOrders;
    if (listIds.length === 0) {
      toast.error("Phải chọn ít nhất 1 mục");
      return;
    }
    const textIds = listIds.join(';');
    var requestApi = `${API_URL_All}${uri}?codes=${textIds}`;

    setIsLoading(true);
    general.downloadFile(requestApi, fileName);
    setIsLoading(false);
  };
  
  const handleExportFile = async (obj) => {
    if (!orderExcelPerm(ORDER_EXCEL_EXPORT_FEATURES[3])) {
      toast.warning("Bạn không có quyền xuất mục này.");
      return;
    }
    downloadFileExcel('/api/import-orders/exportProfileVat', 'Ho-so-line-vat.xlsx');
  };

  //transportation
  const handleExportProfileNormal = async (obj) => {
    if (!orderExcelPerm(ORDER_EXCEL_EXPORT_FEATURES[2])) {
      toast.warning("Bạn không có quyền xuất mục này.");
      return;
    }
    downloadFileExcel('/api/import-orders/downloadProfileLineNormal', 'Ho-so-line-thuong.xlsx');
  };
  return (
    <div>
      <UserLayout>
        <div className="table-responsive web-table" data-orderType={`unconfirmed_${!isMyOrders}`}>
          <div className="container-fluid">
            <div className="row bg-zto">
              <div className='col-12 col-md-2 pt-1 pb-1 fw-bold text-white text-uppercase d-flex align-items-center d-none'>
                Đơn hàng của tôi
              </div>
              <div className="nav-item dropdown col-md-2 ">
                <div className="nav-link dropdown-toggle fw-bold d-flex align-items-center h-100" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                  {isMyOrders && "ĐƠN HÀNG CỦA TÔI"}
                  {!isMyOrders && "ĐƠN VÃNG LAI"}
                </div>
                <ul className="dropdown-menu">
                  {!isMyOrders && (
                    <li><a className="dropdown-item" onClick={(e) => searchOrders({ page: 0, customers: '' })}>Đơn hàng của tôi</a></li>
                  )}
                  {isMyOrders && (
                    <li><a className="dropdown-item" onClick={(e) => searchOrders({ page: 0, customers: 'ZTO-VH00' })}>Đơn vãng lai</a></li>
                  )}
                </ul>
              </div>
              <div className='col-5 col-md-3 pt-1 pb-1'>
                <Form id="form_filter">
                  <div className="input-group search-block">
                    <input name="keyword"
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Tìm kiếm..."
                      value={searchQuery}
                      onChange={(e) => handleSearchChange(e)}
                    />
                    <button className="btn btn-light btn-sm" type="button" title="Tìm kiếm" onClick={(e) => requestSearchOrders({ page: 0 })}>
                      <FaSearch />
                    </button>
                  </div>
                </Form>
              </div>
              <div className='col-7 col-md-7'>
                <div className="flex-end gap-2 list_buttons">
                  {config.lineIds && (config.lineIds.includes(1) || config.lineIds.includes(4) || config.lineIds.includes(11)) && (
                    <button className="btn btn-success btn-sm d-none" onClick={handleOrderEditor} title="Thêm đơn mới ">
                      <FaPlus />
                    </button>
                  )}

                  {config.lineIds && (config.lineIds.includes(1) || config.lineIds.includes(4) || config.lineIds.includes(11)) && (

                    <div className="dropdown">
                      <button className="btn btn-success btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <FaPlus />
                      </button>
                      <ul className="dropdown-menu">
                        <li onClick={handleOrderEditor}><a className="dropdown-item">Tạo đơn thường</a></li>
                        <li onClick={handleMultiOrderEditor}><a className="dropdown-item">Tạo nhiều đơn</a></li>
                        <li onClick={handleAddOrderByExcel}><a className="dropdown-item">Tạo nhiều đơn bằng file excel</a></li>
                      </ul>
                    </div>
                  )}
                  {config.lineIds && config.lineIds.includes(12) && (
                    <button className="btn btn-success btn-sm" onClick={handleOrderVatEditor} title="Thêm đơn VAT ">
                      <FaPlus /> VAT
                    </button>
                  )}
                  {anyOrderExcelPerm && (
                    <div className="dropdown">
                      <button className="btn btn-success btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                        Excel
                      </button>
                      <ul className="dropdown-menu">
                        {orderExcelPerm(ORDER_EXCEL_EXPORT_FEATURES[2]) && (
                          <li onClick={() => handleExportProfileNormal()}><a className="dropdown-item">Xuất hồ sơ thường</a></li>
                        )}
                        {orderExcelPerm(ORDER_EXCEL_EXPORT_FEATURES[3]) && (
                          <li onClick={() => handleExportFile()}><a className="dropdown-item">Xuất hồ sơ VAT</a></li>
                        )}
                      </ul>
                    </div> 
                  )}
                  <button className="btn btn-info btn-sm my-1" onClick={() => handleOpenModal()}>
                    <FaFilter /> Bộ lọc
                  </button>
                </div>
                {!isMyOrders && (
                  <div>
                    <button className="btn btn-info btn-sm my-1" onClick={() => handleOpenTransferRequester()}>
                      Yêu cầu xác nhận đơn
                    </button>
                  </div>
                )}
              </div>
            </div>
            {!user &&
              <p className="text-danger text-center">Vui lòng đăng nhập để xem đơn hàng!</p>
            }
            {user && !config.code && (
              <div>
                <div className="empty-orders-container text-center">
                  <img src="https://cdn-icons-png.flaticon.com/512/2038/2038854.png" alt="Giỏ hàng trống" className="empty-orders-img" />
                  <p className="text-warning mt-3 fs-5 fw-bold">Bạn chưa có đơn hàng nào!</p>
                </div>
              </div>
            )}
            {user && config.code && (
              <>
                <div className="row row-control">
                  <div className="col-md-6 p-0">
                    <div className="text-start mb-2">
                      <div className="d-inline" data-filter-ref="status">
                        {
                          countCountOrderByStatusList.map((obj, index) => (
                            <button key={index}
                              id={"btnFilter" + obj.statusId}
                              className={`btn btn-outline-secondary btn-sm me-2 my-1 ${obj.active ? 'active' : ''}`}
                              onClick={() => { handleOrderStatusFilter(obj.name) }}
                            >
                              {obj.name} <span className="ant-tag">{obj.count}</span>
                            </button>
                          ))
                        }
                      </div>
                      <button className={`btn btn-outline-secondary btn-sm me-2 my-1 ${params.outdate ? 'active' : ''}`} onClick={() => { handleOutdateFilter(30) }}>30 ngày <span className="ant-tag">{pageData.over30DaysCount}</span></button>

                    </div>
                  </div>
                  <div className="col-md-6">
                    <span className="filter-des hidden-close-i2"></span>
                  </div>
                </div>

              </>
            )}
          </div>

          {user && config.code &&(
            <div>

              <section>
                <DataTable maxHeight="calc(100vh - 206px)" className="table-normal" data-loading={isLoading}>
                  <table className="table table-striped table-bordered border-normal">
                    <thead className="table-primary">
                      <tr>
                        {/* {!isMyOrders && ( */}
                          <th rowSpan="2" className='sticky'>
                            <input type="checkbox" title='Check all' className='check_all' onChange={() => handleSelectAll()} />
                          </th>
                        {/* )} */}
                        <th rowSpan="2"></th>
                        <th rowSpan="2" className="text-center">
                          <span>Ngày</span>
                          <span className="filter-ib" data-form="form_filter" data-filter="dates" data-source-key="createdDate" data-source-url={API_URL_All + '/api/import-orders/searchDates'} data-default={year} data-min="120px"><i className="filter-i"></i></span>
                        </th>
                        {showColLine && (
                          <th rowSpan="2">
                            <span>Line</span>
                            <span className="filter-ib" data-form="form_filter" data-filter="lines" data-source-key="list_lines" data-min="100px"><i className="filter-i"></i></span>
                          </th>
                        )}
                        {shippingCodeColSpan > 0 && (
                          <th colSpan={shippingCodeColSpan} className="text-center">
                            Mã vận đơn
                          </th>
                        )}
                        {showColProductName && (
                          <th rowSpan="2">
                            <span>Tên đơn hàng</span>
                            <span className="filter-ib" data-form="form_filter" data-filter="productNames" data-source-url={API_URL_All + '/api/import-orders/searchProductNames'}><i className="filter-i"></i></span>
                          </th>
                        )}
                        {showColPackage && (
                          <th rowSpan="2" className="text-center">
                            Số kiện
                          </th>
                        )}
                        {showColWeightVolume && (
                          <>
                            <th rowSpan="2" className="text-center">
                              kg/m3
                            </th>
                            <th rowSpan="2" className="text-center">
                              Đ.Vị
                            </th>
                          </>
                        )}
                        {showColInsurance && (
                          <th rowSpan="2" className="text-center">
                            Bảo hiểm
                          </th>
                        )}
                        {showColShippingMethod && (
                          <th rowSpan="2">
                            Phương thức lấy hàng
                          </th>
                        )}
                        {showColNote && (
                          <th rowSpan="2">
                            Ghi chú
                          </th>
                        )}
                        {showColProgress && (
                          <th rowSpan="2">
                            <span>Lưu trình</span>
                            <span className="filter-ib" data-form="form_filter" data-filter="status" data-source-key="list_status" data-min="100px"><i className="filter-i"></i></span>
                          </th>
                        )}
                        {isMyOrders && showColReconcile && (
                          <th colSpan="2" className="text-center">
                            <span>Đối soát</span>
                            <span className="filter-ib" data-form="form_filter" data-filter="rateStatus" data-source-key="list_rateStatus"><i className="filter-i"></i></span>
                          </th>
                        )}
                        <th rowSpan="2"></th>
                      </tr>
                      <tr>
                        {showColCnCode && (
                          <th className="text-center">
                            <span>TQ</span>
                            <span className="filter-ib" data-form="form_filter" data-filter="chinaCodes" data-source-key="cnShippingCode" data-source-url={API_URL_All + '/api/import-orders/searchChinaCodes'}><i className="filter-i"></i></span>
                          </th>
                        )}
                        {showColVnCode && (
                          <th className="text-center">
                            <span>VN</span>
                            <span className="filter-ib" data-form="form_filter" data-filter="vietnamCodes" data-source-key="vnShippingCode" data-source-url={API_URL_All + '/api/import-orders/searchVietnamCodes'}><i className="filter-i"></i></span>
                          </th>
                        )}
                        {isMyOrders && showColReconcile && (
                          <th rowSpan="2"></th>
                        )}
                        {isMyOrders && showColReconcile && (
                          <th rowSpan="2"></th>
                        )}
                      </tr>
                    </thead>
                    {pageData.page && pageData.page.content && pageData.page.content.map((order, index) => (
                      <tbody className="tbody-row" key={index}>
                        <tr>
                          {/* {!isMyOrders && ( */}
                            <td title={order.id} className='sticky'>
                              <input className=""
                                type="checkbox"
                                checked={selectedOrders.includes(order.id)}
                                onChange={() => handleSelectOrder(order.id)}
                              />
                            </td>
                          {/* )} */}
                          <td>{(pageData.page.number * pageData.page.size) + index + 1}</td>
                          <td className='text-center'>{general.formatTimeShort(order.createdDate)}</td>
                          {showColLine && (
                            <td className="text-start">{order.lineName}</td>
                          )}
                          {showColCnCode && (
                            <td className="text-danger text-center">{order.cnShippingCode}</td>
                          )}
                          {showColVnCode && (
                            <td className="text-success text-center">{order.vnShippingCode}</td>
                          )}
                          {showColProductName && (
                            <td className="text-start text-truncate mw-150">{order.name}</td>
                          )}
                          {showColPackage && (
                            <td className="text-center">{order.packageNumbers?.toLocaleString("vi-VN")}</td>
                          )}
                          {showColWeightVolume && (
                            <>
                              <td className="text-center">{(order.freightCost >= order.freightCostM3 || order.freightCostM3 === null) ? order.packageUnitValue?.toLocaleString("vi-VN") : order.packageUnitM3?.toLocaleString("vi-VN")}</td>
                              <td className="text-center">{(order.freightCost >= order.freightCostM3 || order.freightCostM3 === null) ? 'kg' : 'm3'}</td>
                            </>
                          )}
                          {showColInsurance && (
                            <td className="text-center">{order.insurancePrice ? order.insurancePrice.toLocaleString("vi-VN") : "0"}</td>
                          )}
                          {showColShippingMethod && (
                            <td className="text-start text-truncate mw-150" title={order.shippingMethod}>{order.shippingMethod}</td>
                          )}
                          {showColNote && (
                            <td className="text-start text-truncate mw-150" title={order.note}>{order.note}</td>
                          )}
                          {showColProgress && (
                            <td className="text-start" style={{ "--bs-table-bg-type": order.colorCode }}>{order.statusName}</td>
                          )}

                          {isMyOrders && showColReconcile && (
                            <td className="text-center fw-bold">
                              {general.formatNumber(order.maxFreghtCost)}
                            </td>
                          )}
                          {isMyOrders && showColReconcile && (
                            <td>
                              <CheckingTicket checkingId={order.statusRateId} checkingName={order.statusRateName} />
                            </td>
                          )}
                          <td>
                            <div className="d-flex align-items-center justify-content-center1 gap-2">
                              <span className="view_progress" title="Lịch sử trạng thái" onClick={(e) => handleViewHistoryInfo(order.id, e)}><EyeIcon /></span>
                              {!order.locked && isMyOrders && (
                                <div title="Cập nhật đơn hàng">
                                  <a className="" onClick={(e) => handleEditor(order.id, order.lineId, e)}>
                                    <FaPen className="text-primary" size={15} />
                                  </a>
                                  <a className="d-none" onClick={() => navigate(`/edit-order-user/${order.id}`)}>
                                    <FaPen className="text-primary" size={15} />
                                  </a>
                                  <a className="d-none1 ps-2" onClick={(e) => handleDeleteOrder(order.id, e)} title="Xóa đơn hàng">
                                    <FaTrash className="text-danger" size={15} />
                                  </a>
                                </div>
                              )}
                              {order.locked && isMyOrders && Number(order.lineId) !== 12 && (
                                <div className="d-flex align-items-center gap-2" title="Đơn đã khóa. Chỉ sửa được tên đơn hàng.">
                                  <a className="" onClick={(e) => handleEditor(order.id, order.lineId, e)}>
                                    <FaPen className="text-primary" size={15} />
                                  </a>
                                  <FaLock className="text-danger mt-1" size={15} />
                                </div>
                              )}
                              {order.locked && isMyOrders && Number(order.lineId) === 12 && (
                                <div className="d-flex align-items-center justify-content-center gap-2" title="Đơn hàng đã được tiếp nhận nên sẽ không thể thay đổi thông tin. Mọi thắc mắc vui lòng liên hệ bộ phận CSKH">
                                  <FaLock className="text-danger mt-1" size={15} />
                                </div>
                              )}
                              {!isMyOrders && (
                                <div>
                                  {order.confirmedText}
                                </div>
                              )}
                            </div>
                          </td>
                        </tr>
                        {order.lineId === 12 && order.details.length > 0 && order.details.map((detail, index2) => (
                          <tr key={index2} className={`row_sub${index2 % 2}`}>
                            {!isMyOrders && (
                              <td className='sticky'>&nbsp;</td>
                            )}
                            {!isMyOrders && (
                              <td className='sticky left-20'>{index2 + 1}</td>
                            )}
                            {isMyOrders && (
                              <td className='sticky'>{index2 + 1}</td>
                            )}
                            <td><div className="ratio ratio-1x1"><img src={`${API_URL_All}/${detail.imagePath}`} /></div></td>
                            <td className="text-start">Mã SP: {detail.productCode}</td>
                            <td className="text-start">
                              <div>
                                <span>{detail.cnCode}</span>
                              </div>
                            </td>
                            <td className="text-start">{detail.vnCode}</td>
                            <td className="text-start">{detail.productName}</td>
                            <td className="text-end">{detail.packageCount}</td>
                            <td colSpan="2" className="text-start">
                              {detail.weight > 0 && (
                                <div>
                                  Nặng: {general.formatNumber(detail.weight)} kg
                                </div>
                              )}
                              {detail.size > 0 && (
                                <div>
                                  Size: {general.formatNumber(detail.size)} m3
                                </div>
                              )}
                            </td>
                            <td className="text-end">{detail.insurancePrice ? detail.insurancePrice.toLocaleString("vi-VN") : "0"}</td>
                            <td className="text-start text-truncate mw-101 small-blocks">
                              <div>
                                <span>S.Lượng: {detail.quantity}</span>
                              </div>
                              <div>
                                <span>Giá khai: {general.formatNumber(detail.priceDeclare)} vnđ</span>
                              </div>
                              <div>
                                <span>Thành tiền: {general.formatNumber(detail.money)} vnđ</span>
                              </div>
                              {detail.shippingMethod}
                            </td>
                            <td className="text-start text-truncate mw-101">{general.mergeText(detail.noteAdmin, detail.noteUser)}</td>
                            <td className="text-start small-blocks d-none">
                              <div>
                                <span>Thuế nhập: {detail.taxImport} %</span>
                              </div>
                              <div>
                                <span>Thuế VAT: {detail.taxVat} %</span>
                              </div>
                            </td>
                            <td style={{ "--bs-table-bg-type": detail.progressColor }}>{detail.progressName}</td>
                            <td>
                              {general.formatNumber(detail.fee)}
                            </td>
                            <td>
                              <CheckingTicket checkingId={detail.checkingId} checkingName={detail.checkingName} />
                            </td>
                            <td className="text-start">
                              <span className="view_progress pe-2" title="Lịch sử trạng thái" onClick={(e) => handleViewOrderDetailHistoryInfo(detail.id, e)}><EyeIcon /></span>
                              {detail.locking && (
                                <LockingTicket isLocking={detail.locking} />
                              )}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                      ))}
                    <tbody>
                      {errorMessage === '' && pageData.page && pageData.page.content && pageData.page.content.length === 0 && (
                        <tr>
                          <td colSpan="19" className="text-center">Không tìm thấy dữ liệu</td>
                        </tr>
                      )}
                      {errorMessage !== '' && (
                        <tr>
                          <td colSpan="19" className="text-center">{errorMessage}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </DataTable>
              </section>

              <div className="my-2 justify-content-end align-items-center">
                <Paging
                  pageData={pageData}
                  onPageChange={handlePageChange}
                  onItemsPerPageChange={handleChangeItemsPerPage}
                  isShowTotal={true}
                  showCheckingFeeTotal={showColReconcile}
                />
              </div>
            </div>
          )}
        </div>

        {pageData.notFoundCodes && pageData.notFoundCodes.length > 0 && (
          <div className="missing-orders">
            <div className="missing-header">
              <span>Mã đơn hàng thiếu</span>
              <i className="close-i close-i0" title="Close" onClick={() => setPageData({ ...pageData, notFoundCodes: [] })}></i>
            </div>
            <div>
              {pageData.notFoundCodes.map((item, index) => (
                <div className="missing-item" key={index}>{item}</div>
              ))}
            </div>
          </div>
        )}

        <input type="hidden" id="editor_lines" value1="TMĐT,Line Thường,Line XT" value={config.normalLineNames} />
        <input type="hidden" id="list_lines" value1="TMĐT,Line Thường,Line XT,Line VAT" value={config.lineNames} />
        <input type="hidden" id="list_status" value1="Đơn mới,Kho TQ,Xe Về VN,Kho VN,Đang Giao,Đã Nhận" value={config.progressNames} />
        <input type="hidden" id="list_rateStatus" value1="Chưa đối soát,Vào phiếu,Đã đối soát" value={config.checkingNames } />
        <input type="hidden" id="list_customers" value="" />

        <div className="d-none th-col th filter-check display">
          <span className="filter-ib" data-form="form_filter" data-filter="deletion"><input type="checkbox" /></span>
          <label className="form-check-label">Đã xóa</label>
        </div>
        <div className="d-none th-col th display">
          <span className="filter-ib" data-form="form_filter" data-filter="outdate"></span>
          <label className="form-check-label">Quá hạn</label>
        </div>
        <div className="d-none th-col th display">
          <span className="filter-ib" data-form="form_filter" data-filter="dateRange"></span>
          <label className="form-check-label">Khoảng ngày</label>
        </div>

        {filterData && (
          <OrderFilter data={filterData} handleSearch={requestSearchOrders} />
        )}

        {orderEditorData && (
          <OrderEditor data={orderEditorData} handleSearch={searchOrders} />
        )}
        {multiOrderEditorData && (
          <MultiOrderEditor data={multiOrderEditorData} handleSearch={searchOrders} />
        )}
        {vatEditorData && (
          <OrderVatEditor data={vatEditorData} handleSearch={searchOrders} />
        )}
        {historyInfoData && (
          <HistoryInfo data={historyInfoData} handleSearch={searchOrders} />
        )}

        {transterRequesterData && (
          <TransferRequester data={transterRequesterData} handleSearch={searchOrders} />
        )}

        <AddOrderByExcelModal
            show={addOrderByExelModal}
            handleClose={handleCloseAddOrderByExcelModal}
            handleSaved={searchOrders}
          />

      </UserLayout>
    </div>
  );
}

export default OrderTable;
